import ExternalLink from "./externalLink";

export const googleMapsLink = (lat: number, lng: number, label?: string) => {
  return <ExternalLink url={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`} label={label ? label : `${lat}, ${lng}`} />;
};

export const googleMapsAddressLink = (address: string, label?: string) => {
  return <ExternalLink url={`https://www.google.com/maps/search/?api=1&query=${address}`} label={label ? label : address} />;
};
